import { render, staticRenderFns } from "./viewMoreDailog.vue?vue&type=template&id=bc8f5840&scoped=true&"
import script from "./viewMoreDailog.vue?vue&type=script&lang=js&"
export * from "./viewMoreDailog.vue?vue&type=script&lang=js&"
import style0 from "./viewMoreDailog.vue?vue&type=style&index=0&id=bc8f5840&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8f5840",
  null
  
)

export default component.exports